import { Component, OnInit, Renderer2, ViewChild, ElementRef, Inject, DOCUMENT, ChangeDetectionStrategy } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { environment } from "../../environments/environment";
import { AbstractComponent } from "./abstract/abstract.component";
import { Router, ActivatedRoute } from "@angular/router";
import { User } from "../entity/User";
import { MatDialog } from "@angular/material/dialog";
import { AuthService } from "../service/auth.service";
import { AnalyticsService } from "../service/analytics.service";
import { GeneralService } from "../service/general.service";
import { HeaderComponent } from "./incs/header.component";

@Component({
    selector: "kilowant-u",
    templateUrl: "../../html/main-kilowant-u.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent]
})
export class KilowantUComponent extends AbstractComponent {
    @ViewChild("beforeYouBegin") beforeYouBegin: ElementRef;

    step: number = 1;
    firstTime: boolean = false;

    isLogged: boolean = false;

    linkHome: string = "/";

    constructor(
        router: Router,
        route: ActivatedRoute,
        private authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        dialog: MatDialog,
        private renderer: Renderer2,
        @Inject(DOCUMENT) private document: Document
    ) {
        super(router, route, dialog, analyticsService, generalService);
        this.renderer.addClass(this.document.body, "kilowantU");
    }

    ngOnInit(): void {
        if (this.authService.isLoggedIn()) {
            this.linkHome = "/user/home";
            this.isLogged = true;
        }
    }

    ngOnDestroy() {
        this.renderer.removeClass(this.document.body, "kilowantU");
    }

    finish(): void {
        if (this.authService.isLoggedIn()) {
            this.generalService.getDetails().then(u => {
                if (u == null) {
                    this.router.navigate(["/user/login"], { queryParams: { redirect: this.router.url } });
                }
                let user = Object.assign(new User(), u);
                user.kilowantUViewed = true;
                this.generalService.changeUserOnboarding(user).then((data: any) => {
                    this.router.navigate(["/user/home"]);
                });
            });
        } else {
            this.router.navigate(["/"]);
        }
    }

    next() {
        this.step++;
    }
}
